import { render, staticRenderFns } from "./DynamicPackingFilter.vue?vue&type=template&id=275a2c78&scoped=true"
import script from "./DynamicPackingFilter.vue?vue&type=script&lang=js"
export * from "./DynamicPackingFilter.vue?vue&type=script&lang=js"
import style0 from "./DynamicPackingFilter.vue?vue&type=style&index=0&id=275a2c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275a2c78",
  null
  
)

export default component.exports